<div class="h-full pl-12" style.padding-top="{{ itemsVerticalOffset }}px">
  <div
    class="h-full {{ itemsContainerCssClass }} pr-12"
    fxLayout="row wrap"
    fxLayoutAlign="start start"
    style.margin-left="{{ -itemsHorizontalOffset }}px"
    style.margin-top="{{ -itemsVerticalOffset }}px"
    fbInfiniteListScroll
    [class.overflow-y-auto]="!outerScroll"
    [endOfData]="endOfData"
    (scrollEvent)="!outerScroll ? loadNext() : null"
  >
    <div
      *ngIf="headerTemplate"
      class="header position-sticky top-0"
      style.padding-left="{{ itemsHorizontalOffset }}px"
      style.margin-bottom="{{ -itemsVerticalOffset }}px"
      [fxFlex]="'100%'"
    >
      <ng-container
        [ngTemplateOutlet]="[childrenTemplates, templates] | findTemplate : headerTemplate"
        [ngTemplateOutletContext]="{ $implicit: {} }"
      ></ng-container>
    </div>

    <ng-container *ngIf="itemsSubject | async as items">
      <ng-container *ngIf="items.length; else noDataFound">
        <div
          *ngFor="let item of items; let first = first; let last = last; let index = index"
          [class.cursor-pointer]="selectable"
          [fxFlex.lg]="itemsWidth | infiniteListItemWidth : 'lg'"
          [fxFlex]="itemsWidth | infiniteListItemWidth : 'md'"
          [fxFlex.sm]="itemsWidth | infiniteListItemWidth : 'sm'"
          [fxFlex.xs]="itemsWidth | infiniteListItemWidth : 'xs'"
          style.padding-left="{{ itemsHorizontalOffset }}px"
          style.padding-top="{{ itemsVerticalOffset }}px"
          (click)="select(item)"
        >
          <ng-container
            [ngTemplateOutlet]="[childrenTemplates, templates] | findTemplate : itemsTemplate"
            [ngTemplateOutletContext]="{
              $implicit: {
                entity: item,
                first: first,
                last: last,
                index: index,
                selected: trackBy(item) === selectedItemId
              }
            }"
          ></ng-container>
        </div>
      </ng-container>
      <ng-template #noDataFound>
        <ng-container *ngIf="(loading.active$ | async) === false">
          <div
            class="no-data w-full d-flex flex-direction-column align-items-center justify-content-center"
            style.padding-left="{{ itemsHorizontalOffset }}px"
            style.padding-top="{{ itemsVerticalOffset }}px"
            [fxFlex]="'100%'"
          >
            <mat-icon class="image" svgIcon="no_items"></mat-icon>
            <div class="message">{{ noDataMessage ? noDataMessage : ('No Items Found' | translate | async) }}</div>
          </div>
        </ng-container>
      </ng-template>
    </ng-container>

    <div
      *ngIf="loading.active$ | async"
      class="bottom-loader h-full d-flex align-items-center justify-content-center"
      [fxFlex]="'100%'"
      style.padding-left="{{ itemsHorizontalOffset }}px"
      style.padding-top="{{ itemsVerticalOffset }}px"
    >
      <fb-loader class="position-relative" [size]="30" [message]="undefined"></fb-loader>
    </div>
  </div>
</div>
